type Props = { className?: string };
export const RedDot = ({ className }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="8"
    viewBox="0 0 8 8"
    fill="none"
    className={className}
  >
    <circle cx="4" cy="4" r="4" fill="#FF2828" />
  </svg>
);
